__turbopack_context__.v({
  "badge": "FewSeatsRemainingBadge-module___g14Fa__badge",
  "badgeLabel": "FewSeatsRemainingBadge-module___g14Fa__badgeLabel",
});
